/** One metered feature's position for the current UTC calendar month (GET /credits, /candi-bank/stats). */
export interface FeatureCredits {
  feature: string;           // e.g. "candi_bank_cv"
  unit: string;              // e.g. "CVs"
  period: string;            // "2026-09"
  monthlyLimit: number | null;   // null = unlimited
  used: number;
  remaining: number | null;      // null = unlimited
  unlimited: boolean;
  resetsAt: number;          // unix seconds, first instant of next month UTC
}

export interface CreditUsageMonth {
  period: string;
  used: number;
}

/** GET /admin/organization/{id}/credits/{feature}/usage */
export interface CreditUsageResponse {
  feature: string;
  unit: string;
  monthlyLimit: number | null;
  unlimited: boolean;
  current: FeatureCredits;
  history: CreditUsageMonth[];
}

export const CANDI_BANK_CV = 'candi_bank_cv';

/** Body of the 402 the bank upload returns when the month's allowance is spent. */
export const CV_CREDITS_EXHAUSTED = 'cv_credits_exhausted';

export function formatResetDate(credits: Pick<FeatureCredits, 'resetsAt'>): string {
  return new Date(credits.resetsAt * 1000).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  });
}

export type CreditTone = 'ok' | 'warn' | 'crit';

export function creditTone(credits: Pick<FeatureCredits, 'monthlyLimit' | 'used' | 'unlimited'>): CreditTone {
  if (credits.unlimited || credits.monthlyLimit === null) return 'ok';
  if (credits.monthlyLimit === 0 || credits.used >= credits.monthlyLimit) return 'crit';
  if (credits.used / credits.monthlyLimit >= 0.8) return 'warn';
  return 'ok';
}
